// Utils
import { placeCaretAtEnd } from '../../utils/keyboard/contentEditable';
import * as typingBuffer from '../../../common/tiptap/utils/typingBufferSingleton';

type BufferedCharacterInsertionOptions = {
    replaceDefaultText?: boolean;
    previousContent?: string;
};

export const handleBufferedCharacterInsertion = (
    element: HTMLElement,
    { replaceDefaultText, previousContent }: BufferedCharacterInsertionOptions,
): boolean => {
    // Check if there are any characters typed before the editor was focused
    // This handles the case where users start typing before clicking on the editable field
    const bufferedChars = typingBuffer.consume();
    if (!bufferedChars) return false;

    const currentContent = element.innerText || '';

    // Determine whether to replace the entire content or append to it
    // Replace scenario: When replaceDefaultText is true AND the current content
    // exactly matches the default placeholder text (children prop)
    // This is useful for fields with placeholder text like "Label" that should
    // be completely replaced when the user starts typing
    const shouldReplace = replaceDefaultText && currentContent === previousContent;

    if (shouldReplace) {
        // Replace all content with buffered chars (for placeholder text)
        element.innerText = bufferedChars;
    } else {
        // Append buffered chars to existing content using DOM insertion
        // First focus the element to ensure proper cursor positioning
        element.focus();

        // Place cursor at the end
        placeCaretAtEnd(element);

        // Insert the buffered characters at the current cursor position
        document.execCommand('insertText', false, bufferedChars);
    }

    // Move cursor to the end of the newly inserted text
    placeCaretAtEnd(element);

    return true;
};
